import locale from './locale';

export const StatusLabels = {
  online: locale['systems.listView.Status-online'],
  offline: locale['systems.listView.Status-offline'],
  withoutAlert: locale['systems.listView.Status-without-alert'],
  hasAlarm: locale['systems.listView.Status-alarm'],
  hasNotification: locale['systems.listView.Status-notification'],
  hasFwUpdate: locale['systems.listView.Status-update'],
};

export const filterToFormatString = (status, intl) =>
  StatusLabels[status] ? intl.formatMessage(StatusLabels[status]) : status;

export const mapAppliedToValueFilters = (appliedFilters = {}) =>
  Object.entries(appliedFilters).reduce(
    (a, [filterField, filterValues = []]) => [
      ...a,
      ...filterValues.map(fv => ({ filterField, filterValue: [fv], active: true })),
    ],
    [],
  );

export const getSystemAddressLine = s =>
  [s?.address?.lineOne, s?.address?.postalCode, s?.address?.city, s?.address?.country?.name].filter(Boolean).join(' ');

export const matchFilter = ({ filterField, filterValue }, filter) =>
  filterField === filter.filterField && filterValue.some(_ => _.includes(filter.filterValue));
